import { jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { Icon } from "@blueprintjs/core";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor((editorState) => {
  return {
    readOnly: editorState.readOnly
  };
})((props) => {
  const { toolbarItemProps, readOnly, disableSetReadOnly } = props;
  const [isLoading, setIsLoading] = useState(false);
  const readOnlyTooltip = ({ readOnly: readOnly2, disableSetReadOnly: disableSetReadOnly2 }) => {
    if (isLoading) {
      return "Loading...";
    } else if (disableSetReadOnly2) {
      return "You do not have permission to edit locks on this sequence";
    }
    return readOnly2 ? "Click to enable editing" : "Click to disable editing";
  };
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        disabled: isLoading || disableSetReadOnly,
        Icon: /* @__PURE__ */ jsx(Icon, { icon: readOnly ? "lock" : "unlock" }),
        onIconClick: () => handleReadOnlyChange(!readOnly, { ...props, setIsLoading }),
        tooltip: readOnlyTooltip({ readOnly, disableSetReadOnly }),
        ...toolbarItemProps
      }
    }
  );
});
export async function handleReadOnlyChange(newVal, { beforeReadOnlyChange, updateReadOnlyMode, setIsLoading = () => {
} }) {
  if (beforeReadOnlyChange) {
    setIsLoading(true);
    const shouldChange = await beforeReadOnlyChange(newVal);
    setIsLoading(false);
    if (shouldChange === false) {
      return;
    }
  }
  updateReadOnlyMode(newVal);
}
